// Snatched Beauties Privé — Brand Data

export const businessInfo = {
  name: "Snatched Beauties Privé",
  legalName: "Snatched Beauties LLC",
  tagline: "Where Luxury Meets Transformation.",
  description:
    "Luxury aesthetics, wellness, and body contouring studio specializing in non-invasive sculpting, lymphatic therapies, and advanced weight optimization protocols.",
  ethos: "Curated treatments. Elevated experience. Visible results.",
  phone: "323-613-5153",
  email: "support@snatchedbeauties.com",
  address: "5710 W. Manchester Ave, Suite 211, Los Angeles, CA 90045",
  hours: {
    weekday: "Monday – Friday · 9:00 AM – 6:00 PM",
    weekend: "Saturday · 10:00 AM – 6:00 PM",
  },
  social: {
    facebook: "https://www.facebook.com/profile.php?id=100073408705616",
    instagram: "https://www.instagram.com/snatched_beauties/",
    youtube: "https://www.youtube.com/channel/UCMwY-4D1_Qpx6piVCn5erhA",
  },
  bookingUrl: "https://calendly.com/info-o6c",
  legacyBookingUrl: "https://www.snatchedbeauties.la/book-appointment/",
};

export const serviceCategories = [
  {
    id: "signature-sculpting",
    eyebrow: "Signature Sculpting Treatments",
    shortLabel: "Sculpting",
    title: "Signature Body Contouring",
    description:
      "Advanced non-invasive body contouring protocols designed to support fat reduction, contouring, and body refinement.",
    services: ["signature_sculpt", "muscle_sculpt_tone"],
  },
  {
    id: "curves-enhancement",
    eyebrow: "Curves + Enhancement",
    shortLabel: "Curves",
    title: "The Privé Lift Collection",
    description:
      "Non-surgical vacuum therapy protocols designed to temporarily lift, shape, and elevate.",
    services: ["prive_lift"],
  },
  {
    id: "recovery-wellness",
    eyebrow: "Recovery & Wellness Rituals",
    shortLabel: "Recovery",
    title: "Lymphatic Renewal Therapy",
    description:
      "Luxury lymphatic drainage, recovery, and ritual treatments to support circulation, de-puffing, and wellness.",
    services: ["lymphatic_renewal", "wood_therapy"],
  },
  {
    id: "skin-rejuvenation",
    eyebrow: "Skin Tightening + Rejuvenation",
    shortLabel: "Skin",
    title: "Refined Skin Rituals",
    description:
      "Electromagnetic and needle-free infusion treatments for a tightened, lit-from-within finish.",
    services: ["rf_skin_tightening", "electroporation"],
  },
  {
    id: "specialty",
    eyebrow: "Specialty Treatments",
    shortLabel: "Specialty",
    title: "Targeted Contour Enhancements",
    description:
      "Focused treatments for stubborn areas requiring more strategic contour support.",
    services: ["fat_dissolve", "meal_prep"],
  },
];

export const serviceImages = {
  signature_sculpt:
    'https://images.unsplash.com/photo-1767972463246-aaf13f2ad8a1?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900',
  muscle_sculpt_tone:
    'https://images.unsplash.com/photo-1577998555981-6e798325914e?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900',
  prive_lift:
    'https://images.unsplash.com/photo-1624923157576-e5e20dfe9a59?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900',
  lymphatic_renewal:
    'https://images.unsplash.com/photo-1752071368979-e26605337768?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900',
  wood_therapy:
    'https://images.unsplash.com/photo-1767043088777-1884c2ef6c97?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900',
  rf_skin_tightening:
    'https://images.unsplash.com/photo-1689103229376-3fbfe1257242?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900',
  electroporation:
    'https://images.unsplash.com/photo-1704118548916-1370403fb1e5?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900',
  fat_dissolve:
    'https://images.unsplash.com/photo-1628282927226-00e5f67d8f66?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900',
  meal_prep:
    'https://images.unsplash.com/photo-1672062519601-1aae37c7f5d2?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900',
  consultation:
    'https://images.unsplash.com/photo-1662749409564-7ddd1dde5900?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900',
};

// Kept for legacy references (Services.jsx has been rewritten; BE fetches dynamically)
export const services = [];

export const pillars = [
  {
    title: "Concierge-style consultations",
    description:
      "Treatment planning designed around your body, goals, and lifestyle.",
  },
  {
    title: "Customized protocols",
    description:
      "Every ritual is curated—never one-size-fits-all. Always intentional.",
  },
  {
    title: "Private luxury setting",
    description:
      "A boutique experience defined by discretion, marble, and soft lighting.",
  },
  {
    title: "Advanced non-invasive solutions",
    description:
      "Modern aesthetic technologies paired with holistic wellness support.",
  },
  {
    title: "Transparent, education-first",
    description:
      "No pressure. No guesswork. Only guidance grounded in your real goals.",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah M.",
    role: "Verified Client",
    text: "From the moment I connected with Leenda, I got incredible energy from her. She's warm, knowledgeable, and genuinely invested in your journey. Every visit feels curated.",
    rating: 5,
  },
  {
    id: 2,
    name: "Jessica R.",
    role: "Verified Client",
    text: "This is the best service—hands down. My lymphatic ritual left me feeling snatched, calm, and glowing. The space is immaculate and the experience feels luxury start to finish.",
    rating: 5,
  },
  {
    id: 3,
    name: "Monica L.",
    role: "Verified Client",
    text: "Welcoming, impeccably clean, and the results speak for themselves. Went in feeling bloated—left feeling sculpted and confident. 110% recommended.",
    rating: 5,
  },
  {
    id: 4,
    name: "Amanda K.",
    role: "Verified Client",
    text: "Leenda is incredibly professional. After only two sessions I started seeing a real difference. The studio is airy, elevated, and never feels clinical.",
    rating: 5,
  },
];

export const stats = [
  { value: "5+", label: "Years of Practice" },
  { value: "500+", label: "Curated Clients" },
  { value: "5,000+", label: "Treatments Delivered" },
];


// Peptide Wellness Programs (Summer 2026 launch — flagship recurring offering)
export const peptidePrograms = [
  {
    id: "starter-sculpt",
    name: "Starter Sculpt",
    tagline: "An entry into wellness consistency.",
    price: 599,
    description:
      "Perfect for clients starting their wellness and body transformation journey.",
    inclusions: [
      "1-month peptide supply",
      "2 in-office administrations weekly",
      "Professional administration by Snatched Beauties",
      "Progress check-ins",
      "Wellness support",
      "Priority rebooking access",
    ],
    bestFor: [
      "First-time clients",
      "Weight management goals",
      "Clients seeking accountability and consistency",
    ],
  },
  {
    id: "snatched-signature",
    name: "Snatched Signature",
    tagline: "Our most-selected transformation cadence.",
    price: 699,
    flagship: true,
    description: "Our most popular transformation package.",
    inclusions: [
      "1-month peptide supply",
      "2 in-office administrations weekly",
      "Personalized progress tracking",
      "Weekly weigh-ins",
      "Body transformation guidance",
      "Priority scheduling",
      "Snatched Beauties wellness support",
    ],
    bonus: [
      "Before & after transformation photos (optional)",
      "VIP client pricing on future wellness services",
    ],
    bestFor: [
      "Serious transformation goals",
      "Clients wanting premium support",
      "Long-term wellness clients",
    ],
  },
  {
    id: "vip-elite",
    name: "VIP Snatched Elite",
    tagline: "Luxury wellness, concierge cadence.",
    price: 999,
    elite: true,
    description: "Luxury wellness + transformation experience.",
    inclusions: [
      "1-month peptide supply",
      "2 weekly VIP administrations",
      "Front-of-line scheduling",
      "Personalized transformation planning",
      "Direct support & accountability",
      "Body sculpting / wellness guidance",
      "Exclusive VIP client perks",
      "Progress documentation",
      "Premium client experience",
    ],
    bonus: [
      "Free consultation for future services",
      "Priority access to new treatments",
      "Exclusive Snatched Beauties VIP offers",
    ],
    bestFor: [
      "High-level clientele",
      "Busy professionals",
      "Clients wanting concierge-style wellness support",
    ],
  },
];

export const peptideAddOns = [
  { name: "Additional wellness consultation", price: "$75" },
  { name: "Body contouring add-on", price: "from $99" },
  { name: "Personalized transformation plan", price: "$149" },
  { name: "VIP fast-track scheduling", price: "$49 / mo" },
  { name: "Meal & lifestyle guidance", price: "$99" },
];
